<div class="outer-container">
  <div *ngIf="council; else noCouncil" class="container">
    <br/>
    <div class="council-card">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Council #{{council.id}} - {{council.name}}</mat-card-title>
          <mat-card-subtitle>{{getDioceseName(council.diocese)}} Diocese | {{council.location}} | Division {{council.division}}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
      <br/>
    </div>
    <div *ngIf="chartData" class="mat-elevation-z1">
      <google-chart type="BarChart" [data]="chartData" [options]="chartOptions"></google-chart>
    </div>
    <br/>
    <div style="width: auto; text-align: center;">
      <button style="width: auto" mat-raised-button color="primary" (click)="enterNewActivity()"><mat-icon style="width: auto">create</mat-icon>&nbsp;&nbsp;Enter New Activity</button>
    </div>
    <br/>
    <div *ngIf="activities" class="activity-list">
      <div *ngFor="let programGroup of this.getProgramGroups()">
        <div *ngIf="programGroup.icon">
          <img style="width: 50px" src="../../assets/{{programGroup.icon}}">
        </div>
        <span class="mat-title">{{programGroup.displayName}} Activities ({{calculatePoints(programGroup)}}/{{programGroup.totalPoints}} points)</span>
        <div class="mat-elevation-z6" *ngIf="(activities | programGroupFilter: programGroup).length > 0; else noData">
          <div>
            <table mat-table [dataSource]="activities | programGroupFilter: programGroup" multiTemplateDataRows>

              <ng-container matColumnDef="activityType">
                <th mat-header-cell *matHeaderCellDef> Activity </th>
                <td mat-cell *matCellDef="let activity">
                    <div *ngIf="activity.activityTitle">
                      {{activity.activityTitle}}
                      <span class="activityDate" *ngIf="activity.activityDate">({{activity.activityDate}})</span>
                    </div>
                    <div>
                      <span class="activityType">{{getActivityNameById(activity.activityTypeId)}}</span>
                      <div *ngIf="getIsSupremeFeaturedProgram(activity)" class="activitySupremeFeaturedProgram">
                          🏅 Supreme Featured Program 🏅
                      </div>
                    </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="activityStatus">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                  <td mat-cell *matCellDef="let activity" [ngClass]="{approved: getActivityStatus(activity) === 'approved', rejected: getActivityStatus(activity) === 'rejected', reviewed: getActivityStatus(activity) === 'reviewed'}">
                    <ng-container *ngIf="activity.activityTypeId !== 'membership-growth-percentage'">
                      <mat-icon *ngIf="getActivityStatus(activity) === 'approved'">check_circle_outline</mat-icon>
                      <mat-icon *ngIf="getActivityStatus(activity) === 'rejected'">highlight_off</mat-icon>
                      <mat-icon *ngIf="getActivityStatus(activity) === 'reviewed'">pending</mat-icon>
                      <br />{{getActivityStatus(activity) | titlecase}}
                    </ng-container>
                    <ng-container *ngIf="activity.activityTypeId === 'membership-growth-percentage'">
                      {{getMembershipGrowthPercentage(activity)}} points
                    </ng-container>
                  </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let activity" [attr.colspan]="displayedColumns.length">
                  <div class="activity-detail"
                        [@detailExpand]="activity == expandedActivity ? 'expanded' : 'collapsed'">
                    <div class="activity-detail-comments">
                      <strong>From State {{programGroup.displayName}} Director - {{programGroup.director.name}}:</strong><br/>
                      <span *ngIf="getProgramDirectorComments(activity); let comments; else noComment" class="comment">{{comments}}</span>
                      <ng-template #noComment>
                        <span class="no-comment">No comments</span>
                      </ng-template>
                      <div *ngIf="isAllowedToGrade(programGroup)">
                          <br/>
                          <button mat-stroked-button color="primary" type="submit" (click)="gradeActivity(activity)">Grade Activity</button>
                      </div>
                    </div>

                  </div>
                </td>
              </ng-container>

              <tr class="activityTable-header-row" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                (click)="activitySelected(row); expandedActivity = expandedActivity === row ? null : row" class="activity-row"
                [class.expanded-activity-row]="expandedActivity === row">
              </tr>

              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="activity-detail-row"></tr>
            </table>
          </div>
        </div>
        <br/>
        <span class="mat-h3">{{programGroup.displayName}} Activity Requirements</span>
        <ul class="programRequirements">
          <li *ngFor="let requirement of programGroup.requirements">{{requirement}}</li>
        </ul>

        <br/><br/>
      </div>
    </div>

    <ng-template #noData>
      <div class="mat-body">No Activities</div>
    </ng-template>
    <!-- {{activities | json}} -->
  </div>
  <ng-template #noCouncil>
    <div class="container">
      <br/>
      Select your council:
      <form class="form" [formGroup]="councilForm">
        <mat-form-field>
          <input matInput type="text" placeholder="Council" formControlName="council" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let council of filteredCouncils | async" [value]="council" (onSelectionChange)="councilSelectionChanged($event)">
              {{council.id}} - {{council.name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>
    </div>
  </ng-template>
</div>
